import React, { createContext, useContext, useEffect, useState } from "react";

import mobileBackground from "./images/mobileBackground.png";
import pcBackground from "./images/pcBackground.png";

const DeviceContext = createContext();

export const DeviceContextProvider = ({ children }) => {
  const [bgImage, setBgImage] = useState(pcBackground);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setBgImage(mobileBackground);
      } else {
        setBgImage(pcBackground);
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <DeviceContext.Provider value={{ bgImage }}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDeviceContext = () => useContext(DeviceContext);
